import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { articles, categories } from '@/mocks/articles';

const hotArticles = articles.filter((a) => a.is_hot || a.is_featured).slice(0, 4);
const latestArticles = articles;

export default function Home() {
  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full h-[520px] md:h-[620px] flex items-end overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Dramatic%20dark%20stage%20with%20warm%20golden%20spotlight%20beams%20cutting%20through%20darkness%2C%20elegant%20red%20velvet%20curtain%20texture%2C%20mysterious%20atmosphere%2C%20dramatic%20theater%20lighting%2C%20rich%20warm%20amber%20and%20crimson%20tones%2C%20abstract%20artistic%20composition%2C%20no%20people%2C%20cinematic%20wide%20shot%2C%20luxurious%20texture%2C%20subtle%20smoke%20effect&width=1920&height=800&seq=gossip-hero-2026-main&orientation=landscape"
            alt="吃瓜爆料 - 娱乐圈内幕追踪"
            title="吃瓜爆料 - 娱乐圈内幕大瓜实时追踪"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

          <div className="relative z-10 w-full pb-16 md:pb-20 px-4 md:px-6">
            <div className="max-w-4xl mx-auto text-center">
              <p className="text-accent-400 text-sm md:text-base font-medium tracking-widest mb-4 uppercase">
                每日黑料合集 · 实时追踪
              </p>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight">
                娱乐圈内幕大瓜
              </h1>
              <p className="text-white/70 text-base md:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
                网曝明星网红塌房、反差视频、不雅黑料持续更新，最全吃瓜情报入口。真实爆料，深扒秘闻，立即体验吃瓜快感！
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full text-base font-semibold bg-accent-500 text-foreground-950 hover:bg-accent-400 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即体验吃瓜快感
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        {/* Hot Articles Section */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
                今日最热黑料
              </h2>
              <p className="text-foreground-500 text-sm md:text-base">
                全网最火爆的娱乐圈内幕，都在这里
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {hotArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          </div>
        </section>

        {/* Categories Navigation */}
        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-12">
              <p className="text-sm text-foreground-400 font-medium mb-2">快速导航</p>
              <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-tight">
                吃瓜频道
              </h2>
              <p className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-tight mt-1">
                全网追踪
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="bg-background-50 rounded-xl p-8 border border-background-200/70 hover:border-primary-300 transition-all duration-300 group"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 mb-5 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                    <i className={`ri-${
                      cat.slug === 'mingxing-tafang' ? 'user-unfollow' : cat.slug === 'wanghong-fanche' ? 'live' : 'tv'
                    }-line text-2xl`}></i>
                  </div>
                  <h3 className="font-heading text-xl font-bold text-foreground-950 mb-2">{cat.name}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed mb-3">{cat.description}</p>
                  <span className="text-xs text-foreground-400">{cat.count} 篇爆料</span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* All Articles */}
        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-10">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新爆料</h2>
                <p className="text-sm text-foreground-500 mt-1">每日更新，不漏任何大瓜</p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {latestArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>

            <div className="mt-12 text-center">
              <Link
                to="/category/mingxing-tafang"
                className="inline-flex items-center gap-2 px-8 py-3 rounded-full text-sm font-semibold border-2 border-foreground-200 text-foreground-700 hover:border-primary-400 hover:text-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                查看更多爆料
                <i className="ri-arrow-down-line"></i>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}